import type { Creator } from '@/types';

type FlagInput = {
  creator: Creator;
  isAdmin: boolean;
  isCollector: boolean;
  isOwner: boolean;
};

export type ActionFlags = {
  canEdit: boolean;
  canDelete: boolean;
  canSanction: boolean;
  canAlert: boolean;
  canRestore: boolean;
  canHardDelete: boolean;
};

function canActOnOwn(args: FlagInput): boolean {
  return args.isAdmin || (args.isCollector && args.isOwner);
}

function canAlertOn(args: FlagInput, isSoftDeleted: boolean): boolean {
  const c = args.creator;
  return args.isAdmin && !c.is_void && !isSoftDeleted && !c.alert_pending_at;
}

export function computeFlags(args: FlagInput): ActionFlags {
  const isSoftDeleted = !!args.creator.deleted_at;
  const isAdminVoided = args.creator.is_void && !args.creator.deleted_at;
  const ownAccess = canActOnOwn(args);
  return {
    canEdit: ownAccess && !isSoftDeleted,
    canDelete: ownAccess && !args.creator.is_void && !isSoftDeleted,
    canSanction: args.isAdmin && !args.creator.is_void,
    canAlert: canAlertOn(args, isSoftDeleted),
    canRestore: ownAccess && isSoftDeleted && !isAdminVoided,
    canHardDelete: args.isAdmin && isSoftDeleted,
  };
}

export function anyActionVisible(f: ActionFlags): boolean {
  return (
    f.canEdit ||
    f.canDelete ||
    f.canSanction ||
    f.canAlert ||
    f.canRestore ||
    f.canHardDelete
  );
}
